module.exports = __webpack_public_path__ + "img/fashion_54.042182d0.jpg";